import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { encodeUriComponentSafe } from 'libs/helpers/http-helper';
import { VehicleApiModels } from 'models/api/vehicle-api.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { VehicleModels } from '../../../../../models/vehicle.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class CarPickerApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'vehicle');
  }

  getMarques() {
    return this.getJson<string[]>('/marques', {});
  }

  getModeles(carSearch: VehicleModels.Search) {
    return this.getJson<string[]>('/modeles', {
      ...encodeUriComponentSafe(carSearch),
    });
  }

  getEnergie(carSearch: VehicleModels.Search) {
    return this.getJson<string[]>('/energies', {
      ...encodeUriComponentSafe(carSearch),
    });
  }

  getChevauxFiscaux(carSearch: VehicleModels.Search) {
    return this.getJson<string[]>('/chevauxfiscaux', {
      ...encodeUriComponentSafe(carSearch),
    });
  }

  getCarrosseries(carSearch: VehicleModels.Search) {
    return this.getJson<string[]>('/carrosseries', {
      ...encodeUriComponentSafe(carSearch),
    });
  }

  getVersions(carSearch: VehicleModels.Search) {
    return this.getJson<VehicleModels.VersionWithIdentifiers[]>('/versions', {
      ...encodeUriComponentSafe(carSearch),
    });
  }

  getIdentifiers(carSearch: VehicleModels.Search) {
    return this.getJson<VehicleModels.Identifiers>('/identifiers', {
      ...encodeUriComponentSafe(carSearch),
    });
  }

  getInformationsFromCodeGta(codeGta: string) {
    return this.getJson<VehicleApiModels.VehicleDetails>('/codeGta/' + codeGta);
  }

  getInformationsFromTypeMine(typeMine: string) {
    return this.getJson<VehicleApiModels.VehicleDetails>(
      '/typeMine/' + typeMine,
    );
  }

  getInformationsFromImmatriculation(immatriculation: string) {
    return this.getJson<VehicleApiModels.VehicleDetails>(
      '/immatriculation/' + immatriculation,
    );
  }
}
